/** Shared product naming — use everywhere for consistent branding. */
export const APP_BRAND_SHORT = 'E-Health';
export const APP_BRAND_TAGLINE = 'Management System';
export const APP_BRAND_FULL = `${APP_BRAND_SHORT} ${APP_BRAND_TAGLINE}`;
